import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal, SectionHead } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

export const FAQ = () => {
  const { t } = useLang();
  return (
    <section id="faq" className="bg-white py-24 sm:py-32" data-testid="faq">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-[1fr_1.4fr] lg:gap-20 lg:px-8">
        <SectionHead eyebrow={t.faq.eyebrow} title={t.faq.title} />
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible defaultValue="item-0" className="divide-y divide-slate-100 border-y border-slate-100">
            {t.faq.items.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-0" data-testid={`faq-item-${i + 1}`}>
                <AccordionTrigger className="font-display py-6 text-left text-lg font-bold tracking-tight text-[var(--ink)] hover:no-underline [&>svg]:h-5 [&>svg]:w-5 [&>svg]:text-[var(--coral)]" data-testid={`faq-trigger-${i + 1}`}>{f.q}</AccordionTrigger>
                <AccordionContent className="pb-6 text-base leading-relaxed text-[var(--mist)]">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
